import { gridGutter1q3, gridGutter1q1dot5, gridGutter } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import { white, green } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

const greyTitle = "#8c9799";
const grey = "#6e798e";
const dividerColor = "#c8ccd4";
const baseColor = "#f8f8f8";


export const collapse =  `
	padding-top: ${gridGutter1q1dot5 / 1.5}px;
	padding-bottom: ${gridGutter1q1dot5 / 3}px;
	padding-left: ${gridGutter}px;
	background-color: ${white};
	border-bottom: solid 1px ${dividerColor};
	border-radius: 4px;
	
	@media all and (max-width: 767px) {
		margin: 0;
		padding: 0 8px ${gridGutter}px;
	}

	@media all and (max-width: 991px) {
		margin: 15px 0 0;
		padding-bottom: ${gridGutter}px;
	}

	.collapse {
		&__content {
			display: flex;
			margin-bottom: 44px;
			@media (max-width: 767px) {
				flex-wrap: wrap;
				margin-right: 0;
			}
			justify-content: space-between;
			margin-right: ${gridGutter}px;
		}
		&__title {
			font-size: 16px;
			font-weight: bold;
			color: ${greyTitle};
		}

		&__text {
			font-weight: 500;
			color: ${grey};
			max-width: 539px;
			padding-right: ${gridGutter1q3}px;
			@media (max-width: 767px) {
				width: 100%;
				max-width: 100%;
			}
		}

		&__button {
			@media (max-width: 767px) {
				width: 100%;
			}
			button {
				padding: 12px 16px;
				background-color: ${white};
				color: ${green};
				&:hover {
					background-color: #edf3f8;
				}
			}
		}

		&__row {
			margin-bottom: ${gridGutter1q1dot5 / 3}px;
		}

		&__details-button {
			width: 40px;
			height: 40px;
			background: ${baseColor};
			position: absolute;
			bottom: -20px;
			left: calc(50% - 20px);
			border: solid 1px ${dividerColor};
			transform: rotate(45deg);
			border-radius: 100%;
			font-size: 60px;
			text-align: center;
			display: flex;

			& .btn {
				overflow: initial;
				background: transparent;
				padding: 0;
				@media (min-moz-device-pixel-ratio: 0) {
					padding: 15px 0 15px 5px;
				}
				display: flex;
				justify-content: center;
				align-items: flex-end;
				transform: rotate(-45deg);
				box-shadow: none;
			}

			& span {
				position: absolute;
				margin-top: -42px;
				font-size: 12px;
				font-weight: 500;
				color: #5a667f;
			}

			& i {
				font-size: 14px;
				position: absolute;
				top: 7px;
			}

			&::before {
				content: "";
				display: block;
				border: solid 24px ${baseColor};
				border-bottom: 10px;
				top: 13px;
				left: 6px;
				transform: rotate(-45deg);
				position: absolute;
			}

			@media (max-width: 991px) {
				& {
					bottom: -19px
				}
				&::before {
					top: 14px !important;
					left: -2px !important;
					right: -25px;
					transform: rotate !important;
				}
			}

			&.opened {
				& i {
					transform: rotate(180deg);
				}
			}
		}
	}
`;
